module.exports = __webpack_public_path__ + "img/steps-train.3726e08d.png";